import { useAuthentication } from "../providers/AuthenticationProvider";
import { Redirect } from "../use/redirect";

export default function UpscopeRoot() {
  const { teamMemberships } = useAuthentication();

  if (!teamMemberships) return <Redirect to={["up.auth.login", { returnHere: false }]} />;

  if (teamMemberships.every((membership) => membership.isOwner && !membership.team.onboardingCompleted))
    return <Redirect to={["up.onboarding", { teamDomain: teamMemberships[0]!.team.domain }]} />;

  const products = teamMemberships.flatMap((membership) => membership.team.products);

  switch (products[0]) {
    case "helloscreen":
      return <Redirect to={["hs.root", {}]} />;
    case "cobrowsingapi":
      return <Redirect to={["co.root", {}]} />;
    case "livedocument":
      return <Redirect to={["ld.root", {}]} />;
    case "userview":
      return <Redirect to={["uv.root", {}]} />;
    default:
      return <Redirect to={["up.onboarding.purchase", { teamDomain: teamMemberships[0]!.team.domain }]} />;
  }
}
